import { render, staticRenderFns } from "./ModalAprovarOuRecusarOrcamento.vue?vue&type=template&id=d412fd7a"
import script from "./ModalAprovarOuRecusarOrcamento.vue?vue&type=script&lang=ts"
export * from "./ModalAprovarOuRecusarOrcamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports